import { useNavigate } from 'react-router-dom'
import { mockComplianceServices } from '../../../mock'
import Footer from '../../footer'
import NavBar from '../../nav'
import './index.scss'

const ComplianceServices = () => {
  const navigate = useNavigate()

  return <>
    <NavBar />
    <div className='compliance__logo' />
    <div className='compliance'>
      <p className='compliance__header'>Compliance Services</p>
      <div className='compliance__grid'>
        {mockComplianceServices.map((item, idx) =>
          <div key={idx} className='compliance__block-text'>
            <p>{item.title}</p>
            <p>{item.content}</p>
            <p className='a' onClick={() => navigate('/')}>View More</p>
          </div>)
        }
      </div>
    </div>
    <Footer />
  </>
}

export default ComplianceServices